import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ChatWidget } from "./ChatWidget";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const lenis = lenisRef.current;
    if (hash) {
      let attempts = 0;
      const id = setInterval(() => {
        attempts += 1;
        const el = document.querySelector(hash);
        if (!el) {
          if (attempts > 24) clearInterval(id);
          return;
        }
        const target = el.getBoundingClientRect().top + window.scrollY - 96;
        if (Math.abs(window.scrollY - target) < 8 || attempts > 24) {
          clearInterval(id);
          return;
        }
        const l = lenisRef.current;
        if (l) l.scrollTo(target, { immediate: true, force: true });
        else window.scrollTo(0, target);
      }, 150);
      return () => clearInterval(id);
    }
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return (
    <div className="App relative">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};
